/* eslint-disable @typescript-eslint/no-explicit-any */
import _ from 'lodash';

import { getDefaultCurrencyForCountry } from '@tock/shared/utils/supportedCountries';
import { getDefaultLocale } from 'state/locale';
import AppConstants from 'constants/AppConstants';

const initialState = {
  business: {
    address: '',
    city: '',
    country: '',
    name: '',
    phone: '',
    state: '',
    timeZone: '',
    zipCode: '',
    currency: '',
  },
  businessGroup: null,
  isInitialized: false,
  stepsCompleted: [],
  password: null,
  patron: null,
  tos: null,
  shouldRefreshOnboardingSteps: false,
};

function parseOnboardingData(onboarding: any) {
  const cityParts = onboarding.businessCity.split(',');
  const city = cityParts[0];
  const state = cityParts.length > 1 ? _.tail(cityParts).join(', ') : null;
  return {
    business: {
      city,
      state,
      country: onboarding.businessCountry.toUpperCase(),
      name: onboarding.businessName,
      currencyCode: getDefaultCurrencyForCountry(onboarding.businessCountry.toUpperCase()),
    },
  };
}

function parseOnboardingCompletedSteps(onboarding: any) {
  return {
    businessGroup: onboarding.businessGroup,
    stepsCompleted: onboarding.state,
    isInitialized: true,
  };
}

export default function reducer(state = initialState, action: BaseTockAction) {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.ONBOARDING_STORE_SET_REFRESH_ONBOARDING: {
      return { ...state, shouldRefreshOnboardingSteps: payload };
    }
    case AppConstants.BUSINESS_LOCALES_AVAILABLE_UPDATE: {
      const country = payload;
      const newBusiness = {
        ...state.business,
        // Set the locale to the first specified for the country
        locale: getDefaultLocale(country),
      };
      return {
        ...state,
        business: newBusiness,
      };
    }
    case AppConstants.ONBOARDING_FETCH_TIME_ZONE_DONE: {
      const newBusiness = {
        ...state.business,
        timeZone: payload.timeZoneId,
      };
      return {
        ...state,
        business: newBusiness,
      };
    }
    case AppConstants.ONBOARDING_GET_BUSINESS_DONE: {
      const business = parseOnboardingData(payload);
      return {
        ...state,
        ...business,
      };
    }
    case AppConstants.ONBOARDING_UPDATE_COMPLETED_STEP:
    case AppConstants.ONBOARDING_STEPS_FETCH_DONE: {
      const onboarding = parseOnboardingCompletedSteps(payload);
      return {
        ...state,
        ...onboarding,
      };
    }
    case AppConstants.ONBOARDING_UPDATE_STORE_STATE: {
      const newState = _.merge(_.cloneDeep(state), _.cloneDeep(payload));
      newState.business.currencyCode = getDefaultCurrencyForCountry(newState.business.country);
      return newState;
    }
    case AppConstants.UPDATED_TERMS_OF_SERVICE_FETCH_DONE: {
      return {
        ...state,
        tos: payload,
      };
    }
    case AppConstants.ONBOARDING_STEPS_FETCH_FAILED: {
      return {
        ...state,
        isInitialized: true,
      };
    }
    default:
      return state;
  }
}
